import HotelEvent from '../../event/HotelEvent'
import AppDispatcher from '../../core/AppDispatcher'

const onEdit = (name, value) => {
  AppDispatcher.dispatchWithType(HotelEvent.onEdit, { name: name, value: value })
}

export default onEdit
